import {Map} from "immutable";

function buildPayload(method, options=Map()) {

  let data = {
    method: method.toUpperCase(),
    mode: "cors",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json"
    }
  }  

  if (options.has("token")) {
    data.headers["Authorization"] = `Bearer ${options.get("token")}`
  }

  if (options.has("payload")) {
    data.body = JSON.stringify(options.get("payload"));
  }

  return data;
}

export function buildPostPayload(payload) {
  return buildPayload("POST", Map({
    payload: payload
  }));
}

export function buildAuthPostPayload(token, payload) {
  return buildPayload("POST", Map({
    payload: payload,
    token: token
  }));
}

export function buildDeletePayload(payload) {
  return buildPayload("DELETE", Map({
    payload: payload
  }));
}

export function buildAuthDeletePayload(token, payload) {
  return buildPayload("DELETE", Map({
    payload: payload,
    token: token
  }));
}

export function buildPutPayload(payload) {
  return buildPayload("PUT", Map({
    payload: payload
  }));
}

export function buildAuthPutPayload(token, payload) {
  return buildPayload("PUT", Map({
    payload: payload,
    token: token
  }));
}

export function buildGetPayload() {
  return buildPayload("GET");
}

export function buildAuthGetPayload(token) {
  return buildPayload("GET", Map({
    token: token
  }));
}